module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4iQnr"))).then(() => parcelRequire('jpLfE'));